import { useEffect, useState } from 'react'
import { version } from '../../../../../package.json'
import { useSessionData } from '../../../../components/sessionContext'
import axios from 'axios'

// styles
import './index.css'

const Footer = () => {
  const [serverVersion, setServerVersion] = useState('1.0.0')

  const session = useSessionData()
  let uri = 'http://localhost:4000'
  if (session.get('server')) uri = session.get('server')

  useEffect(() => {
    if (session) {
      try {
        axios.get(uri, {
          credentials: 'same-origin'
        }).then(resp => {
          if (resp.data.rehability) setServerVersion(resp.data.rehability)
        })
      } catch (err) {
        console.log(err)
      }
    }
  }, [session])

  return (
    <div className='Footer'>
      Rehability - Admin: v{version} - Server: v{serverVersion} - <a href='https://munogu.com' target='_blank' rel='noopener noreferrer'>Munogu</a>
    </div>
  )
}

export default Footer
